module.exports = __webpack_public_path__ + "img/erqeima.428be32c.png";